export default "__VITE_ASSET__CVmu6ROo__"